import {EvReactModal} from '../../modal/EvReactModal';
import {EvConfirmWithCheckbox} from '../../modal/EvConfirmWithCheckbox';

interface Props {
  modal: 'closed' | 'open';
  labelHeader: string;
  labelCheckbox: string;
  labelButton: string;
  response: (result: 'force' | 'abort') => void;
}
export function WorkflowPositionMissingGoldPriceAlertModal(props: Props) {
  const closeModal: () => void = () => {
    props.response('abort');
  };

  return <>
    <EvReactModal contentLabel="Goldpreis Position fehlt!"
                  showModal={props.modal === 'open'}
                  modalClosed={closeModal}>
      <EvConfirmWithCheckbox text={props.labelHeader}
                             labelCheckbox={props.labelCheckbox}
                             labelButton={props.labelButton}
                             response={(r) => props.response(r ? 'force' : 'abort')} />
    </EvReactModal>
  </>;
}
